"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.findYearClosestToRef = exports.findMostLikelyADYear = void 0;

var dayjs_1 = __importDefault(require("dayjs"));

function findMostLikelyADYear(yearNumber) {
  if (yearNumber < 100) {
    if (yearNumber > 50) {
      yearNumber = yearNumber + 1900;
    } else {
      yearNumber = yearNumber + 2000;
    }
  }

  return yearNumber;
}

exports.findMostLikelyADYear = findMostLikelyADYear;

function findYearClosestToRef(refDate, day, month) {
  var refMoment = dayjs_1.default(refDate);
  var dateMoment = refMoment;
  dateMoment = dateMoment.month(month - 1);
  dateMoment = dateMoment.date(day);
  dateMoment = dateMoment.year(refMoment.year());
  var nextYear = dateMoment.add(1, "y");
  var lastYear = dateMoment.add(-1, "y");

  if (Math.abs(nextYear.diff(refMoment)) < Math.abs(dateMoment.diff(refMoment))) {
    dateMoment = nextYear;
  } else if (Math.abs(lastYear.diff(refMoment)) < Math.abs(dateMoment.diff(refMoment))) {
    dateMoment = lastYear;
  }

  return dateMoment.year();
}

exports.findYearClosestToRef = findYearClosestToRef;